module.exports = __webpack_public_path__ + "img/error_conexion.eef54a7e.png";